import React from "react";
import InfoModal from "../../../../../../components/modal/InfoModal";

// Edit popups on My Page (email, password, billing…): centred title, grey
// description, then the form (children). Same layout as the cart's
// "confirm booking" popup (cart/_components/CheckoutConfirmationModal); the
// form's buttons use ModalButtonRow / ModalButton from
// components/modal/ModalButtons, which share that popup's button styles.
const ModalEditInfo = ({
  show,
  children,
  onClose,
  title,
  description,
}) => {
  return (
    <InfoModal show={show} onClose={onClose} paddingBody="tw:pt-0 tw:-mt-8 tw:mb-8 tw:mx-8" modalSize="tw:max-w-xl">
      <p className="tw:text-center tw:mt-4 tw:mb-0 tw:!text-[18px] tw:!text-[#212529]">{title}</p>
      {description ? <p className="tw:text-center tw:mt-2 tw:!text-[#7C7B7B]">{description}</p> : null}
      {/* Padding on a wrapper, not margin on the <p>: page CSS resets <p> margins. */}
      <div className="tw:pt-6">{children}</div>
    </InfoModal>
  );
};

export default ModalEditInfo;
